<template>
  <b-modal ref="modal" hide-footer title="Client Lost Callback">
    <b-row class="my-1">
      <b-col md="4">
        <label for="reason">Client Lost Reason</label>
      </b-col>
      <b-col md="8">
        <b-form-input id="reason" v-model="clientLostReason"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="9"> </b-col>
      <b-col md="3">
        <b-button
          class="mt-3"
          variant="success"
          block
          @click="saveReason"
        >
          <font-awesome-icon icon="check" /> Save
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
  props: {

    save: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      clientLostReason: null
    };
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    saveReason() {
        this.save(this.clientLostReason);
        this.hideModal();
    },
  },
};
</script>
